<template>
	<div>
		<breadcrumbs>
            <router-link to="/">Mis cursos</router-link>
            <router-link v-if="lesson" :to="{ name: 'curso', params: { id: lesson.course_id }}">{{ lesson.course_title }}</router-link>
            <span v-if="lesson">{{ lesson.title }}</span>
		</breadcrumbs>
        <section class="search-section ss-other-page">
            <div class="container">
                <div class="search-warp">				
                    <div class="row">
                        <div class="col-lg-10 offset-lg-1">
                            <!-- search form -->
                            <form class="course-search-form">
                                <h2 v-if="lesson" class="text-white" style="text-align:center;"> {{ lesson.title }}</h2>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>
		<section v-if="lesson" class="lesson__container container mt-4 mb-3">
            <!-- <div class="lesson__container__audio" v-if="lesson.backtrack">
                <p class="h5 lesson__container__audio-title text-left ml-3">Pista de acompañamiento</p>
                <audio class="lesson__container__audio-player w-100 mb-3" controls>
                    <source :src="lesson.backtrack" type="audio/mpeg">
                    Tu navegador no es compatible con este archivo de audio.
                </audio>
            </div> -->
            <video v-if="lesson.video && videoID == null" class="lesson__container-video" controls @ended="onEnd()" :poster="lesson.image">
                <source :src="lesson.video" type="video/mp4">
                Tu navegador no es compatible con este archivo de vídeo.
            </video>
            <div style="position: relative; padding-top: 56.25%;" v-show="lesson.video && videoID != null">
                <iframe ref="lessonvideo" :src="videoURL" style="border: none; position: absolute; top: 0; left: 0; height: 100%; width: 100%;" allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;" allowfullscreen="true" @ended="onEnd()"></iframe>
            </div>
            <a v-if="lesson.video" :href="downloadVideoURL" target="_blank" download class="lesson__container__resource__content-button site-btn header-btn mr-0 ml-3"><font-awesome-icon class="mr-1" icon="download" /> Descargar video</a><br>
            <div v-if="lesson.tablature_pdf || lesson.backtrack">
                <h2 class="text-left mb-0 mt-4 ml-1">Material de la lección</h2>
                <hr class="mt-2">
                <div class="lesson__container__resources">
                    <div class="lesson__container__resource" v-for="(backtrack, index) in backtracks" :key="backtrack.path">
                        <div class="d-flex lesson__container__resource__content" @click="hideResource(backtrack)">
                            <p class="h5 lesson__container__resource__content-title text-left col">
                                <font-awesome-icon class="mr-1" icon="play-circle"  />
                                Pista de acompañamiento {{index + 1}}
                            </p>
                            <font-awesome-icon v-if="!backtrack.visible" class="mr-3 lesson__container__resource__content-icon" icon="angle-down"/>
                            <font-awesome-icon v-else class="mr-3 lesson__container__resource__content-icon" icon="angle-up"/>
                        </div>
                        <transition name="fade">
                            <audio v-show="backtrack.visible" class="lesson__container__audio-player" controls>
                                <source :src="backtrack.path" type="audio/mpeg">
                                Tu navegador no es compatible con este archivo de audio.
                            </audio>
                        </transition>
                    </div>
                </div>
                <div class="lesson__container__resources" v-if="!isAndroid()">
                    <div class="lesson__container__resource" v-for="(tablature, index) in tablatures" :key="tablature.path">
                        <div class="d-flex lesson__container__resource__content" @click="hideResource(tablature)">
                            <p class="h5 lesson__container__resource__content-title text-left col">
                                <font-awesome-icon class="mr-1" icon="music"  />
                                Tablatura {{index + 1}}
                            </p>
                            <a v-if="lesson.tablature" :href="tablature.gpx" class="lesson__container__resource__content-button site-btn header-btn"><font-awesome-icon class="mr-1" icon="download" /> Tablatura Guitar Pro (GPX)</a>
                            <font-awesome-icon v-if="!tablature.visible" class="mr-3 lesson__container__resource__content-icon" icon="angle-down"/>
                            <font-awesome-icon v-else class="mr-3 lesson__container__resource__content-icon" icon="angle-up"/>
                        </div>
                        <transition name="fade">
                            <object v-show="tablature.visible" type="application/pdf" :data="tablature.path+'#view=FitH'" width="100%" height="500" class="lesson__container-pdf"></object>
                        </transition>
                    </div>
                </div>
                <div class="lesson__container__resources" v-else>
                    <div class="lesson__container__resource" v-for="(tablature, index) in tablatures" :key="tablature.path">
                        <div class="d-flex lesson__container__resource__content" @click="hideResource(tablature)">
                            <p class="h5 lesson__container__resource__content-title text-left col">
                                <font-awesome-icon class="mr-1" icon="music"  />
                                Tablatura {{index + 1}}
                            </p>
                            <a v-if="tablature.gpx" :href="tablature.gpx" class="lesson__container__resource__content-button site-btn header-btn mr-0 ml-3"><font-awesome-icon class="mr-1" icon="download" /> Tablatura Guitar Pro (GPX)</a>
                            <a v-if="tablature.path" :href="tablature.path" target="_blank" download class="lesson__container__resource__content-button site-btn header-btn mr-0 ml-3"><font-awesome-icon class="mr-1" icon="download" /> Tablatura PDF</a>
                        </div>
                    </div>
                </div>
                <div class="lesson__container__resources" v-if="!isAndroid()">
                    <div class="lesson__container__resource" v-for="(teory, index) in teories" :key="teory.path">
                        <div class="d-flex lesson__container__resource__content" @click="hideResource(teory)">
                            <p class="h5 lesson__container__resource__content-title text-left col">
                                <font-awesome-icon class="mr-1" icon="file-pdf"  />
                                Teoría {{index + 1}}
                            </p>
                            <font-awesome-icon v-if="!teory.visible" class="mr-3 lesson__container__resource__content-icon" icon="angle-down"/>
                            <font-awesome-icon v-else class="mr-3 lesson__container__resource__content-icon" icon="angle-up"/>
                        </div>
                        <transition name="fade">
                            <object v-show="teory.visible" type="application/pdf" :data="teory.path+'#view=FitH'" width="100%" height="500" class="lesson__container-pdf"></object>
                        </transition>
                    </div>
                </div>
                <div class="lesson__container__resources" v-else>
                    <div class="lesson__container__resource" v-for="(teory, index) in teories" :key="teory.path">
                        <div class="d-flex lesson__container__resource__content" @click="hideResource(teory)">
                            <p class="h5 lesson__container__resource__content-title text-left col">
                                <font-awesome-icon class="mr-1" icon="file-pdf"  />
                                Teoría {{index + 1}}
                            </p>
                            <a :href="teory.path" target="_blank" download class="lesson__container__resource__content-button site-btn header-btn mr-0 ml-3"><font-awesome-icon class="mr-1" icon="download" /> Descargar PDF</a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="lesson__container-navigation row mt-5">
                <div class="col-6 text-left">
                    <router-link v-if="lesson.previous_lection_id" :to="{ name: 'leccion', params: { id: lesson.previous_lection_id }}" ><font-awesome-icon class="mr-2" icon="angle-left"  /> Lección anterior</router-link>
                </div>
                <div class="col-6 text-right">
                    <router-link v-if="lesson.next_lection_id" :to="{ name: 'leccion', params: { id: lesson.next_lection_id }}" class="col-6 text-right">Siguiente lección <font-awesome-icon class="ml-2" icon="angle-right"  /></router-link>
                </div>
            </div>
		</section>
		<div class="loader-container pt-5" v-else>
			<div class="loader mt-0 mb-0"></div>
		</div>
	</div>
</template>

<script>
import axios from 'axios';
import { API_URL } from '@/config.js'

import Breadcrumbs from '@/components/Breadcrumbs.vue'

export default {
    name: 'lesson',
    components: {
        Breadcrumbs
    },
	data() {
		return {
            lesson: null,
            backtracks: [],
            tablatures: [],
            teories: [],
            cloudVideoURL: 'https://watch.cloudflarestream.com/',
            videoID: null
		}
    },
    watch: {
        videoID: function (newID, oldID) {
            if (newID != null && newID != oldID) {
                setTimeout(() => {
                    if (this.$refs.lessonvideo) {
                        // eslint-disable-next-line
                        Stream(this.$refs.lessonvideo).addEventListener("ended", () => this.onEnd());
                    }
                }, 10000);
            }
        }
    },
	created() {
        this.getLesson();
    },
	methods: {
		getLesson() {
            let config = {
                headers: {
                    'Authorization': 'Bearer ' + this.$store.getters.user.token
                }
            }
            axios.get(`${API_URL}/private/user/lection/${this.$route.params.id}`, config)
				.then(response => {
                    if (response.status == 200) {
                        this.lesson = response.data;
                        if (this.lesson.backtrack) {
                            this.lesson.backtrack.split('|').forEach(backtrack => {
                                this.backtracks.push({
                                    path: backtrack,
                                    visible: false
                                });
                            });
                        }
                        if (this.lesson.tablature_pdf) {
                            let gpx = this.lesson.tablature.split('|');
                            this.lesson.tablature_pdf.split('|').forEach((tablature, index) => {
                                if (tablature.includes('tablatura')) {
                                    this.tablatures.push({
                                        path: tablature,
                                        gpx: gpx[index],
                                        visible: false
                                    });
                                } else {
                                    this.teories.push({
                                        path: tablature,
                                        visible: false
                                    });
                                }
                            });
                        }
                        if (this.lesson.video) {
                            if (this.lesson.video.startsWith(this.cloudVideoURL)) {
                                this.videoID = this.lesson.video.split(this.cloudVideoURL)[1]
                            }
                        }
                        if (this.lesson.progress && this.lesson.progress.id == 1) {
                            axios.put(`${API_URL}/private/user/lections/${this.$route.params.id}/progress`, { progress_id: 2 }, config).then(response => {
                                console.log(response);
                                if (response.status == 200) {
                                    this.$store.commit('setLessonProgress', this.$route.params.id, 2);
                                } else {
                                    this.$router.push('/');
                                }
                            })
                            .catch(() => {
                                this.$router.push('/');
                            });
                        }
                    } else {
                        this.$router.push('/');
                    }
				})
				.catch((e) => {
                    console.error(e);
					this.$router.push('/');
				});
        },
        hideResource(resource) {
            resource.visible = !resource.visible;
        },
        onEnd() {
            if (this.lesson.progress && this.lesson.progress.id != 3) {
                let config = {
                    headers: {
                        'Authorization': 'Bearer ' + this.$store.getters.user.token
                    }
                };
                axios.put(`${API_URL}/private/user/lections/${this.$route.params.id}/progress`, { progress_id: 3 }, config).then(response => {
                    if (response.status == 200) {
                        this.$store.commit('setLessonCompleted', this.$route.params.id);
                    } else {
                        this.$router.push('/');
                    }
                })
                .catch((e) => {
                    console.error(e);
                    this.$router.push('/');
                });
            }
        },
        isAndroid() {
            return /Android|webOS|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
        }
    },
    computed: {
        videoURL: function() {
            return this.videoID != null ? `https://iframe.videodelivery.net/${this.videoID}?poster=${this.lesson.image}` : null
        },
        downloadVideoURL: function() {
            return this.lesson.image.replace('jpg', 'mp4').replace('.png','.mp4');
        }
    }
}
</script>

<style lang="scss">
	@import "@/variables.scss";
    .ss-other-page {
        margin-top: -86px !important;
        .search-warp {
            padding: 0 5px !important;
            background: $main-color;
            .course-search-form {
                height: 86px;
                display: flex;
                h2 {
                    margin: auto;
                    font-size: 1.8rem;
                    @media only screen and (max-width: 991px) {
                        font-size: 1.7rem;
                    }
                    @media only screen and (max-width: 767px) {
                        font-size: 1.6rem;
                    }
                    @media only screen and (max-width: 575px) {
                        font-size: 1.5rem;
                    }
                }
            }
        }
    }
    .lesson__container {
        padding-bottom: 30px;
         h2 {
            font-size: 1.7rem;
            @media only screen and (max-width: 991px) {
                font-size: 1.5rem;
            }
            @media only screen and (max-width: 767px) {
                font-size: 1.4rem;
            }
            @media only screen and (max-width: 575px) {
                font-size: 1.3rem;
            }
        }
        &__resources {
            margin-bottom: 20px;
        }
        &__resource {
            border-bottom: 1px solid #ddd;
            background: #fbfbfb;
            &__content {
                padding: 25px;
                cursor: pointer;
                transition: all 0.07s linear;
                &:hover {
                    background: #f2f3f4;
                }
                &-title {
                    margin: auto 0;
                    @media only screen and (max-width: 991px) {
                        font-size: 1.2rem;
                    }
                    @media only screen and (max-width: 767px) {
                        font-size: 1.1rem;
                    }
                    @media only screen and (max-width: 575px) {
                        font-size: 1rem;
                    }
                }
                &-button {
                    padding: 5px 10px;
                    font-size: 14px;
                    margin-right: 30px;
                    margin-left: 15px;
                }
                &-icon {
                    font-size: 24px;
                    margin: auto;
                    color: #ffba00;
                }
            }
            &__file {
                transition: all 1s linear;
                padding: 20px 30px 15px 30px;
            }
        }
        &-video, &__audio-player {
            width: calc(100% - 40px);
            margin: 20px auto 13px auto;
            transition: all 0.07s linear;
            &:focus {
                outline: none;
            }
        }
        &__audio {
            &-title {
                font-size: 1.15rem;
            }
        }
        &-pdfbuttons {
            display: flow-root;
            @media only screen and (max-width: 575px) {
                a, button {
                    width: 100%;
                    margin: 5px 0 !important;
                }
            }
        }
        &-pdf {
            height: 600px;
            transition: all 0.3s linear;
            border: 1px solid #DDD;
        }
        .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
            opacity: 0;
            height: 0;
        }
        &-navigation {
            a {
                color: $main-color-brown;
                font-size: 1.3em;
                @media only screen and (max-width: 991px) {
                    font-size: 1.2rem;
                }
                @media only screen and (max-width: 767px) {
                    font-size: 1.1rem;
                }
                @media only screen and (max-width: 575px) {
                    font-size: 1rem;
                }
                svg {
                    font-size: 1.1em;
                    vertical-align: sub;
                }
                &:hover {
                    text-decoration: none;
                    color: $main-color-brown-dark;
                }
            }
        }
    }
    .loader-container {
		min-height: calc(100vh - 323px);
	}
</style>